import { Box, Breadcrumbs, Grid, Typography } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useSettingsContext } from "../settings";
import { useMemo } from "react";

const FormBreadCrumbs = () => {
  const { backPage, tabId } = useParams();

  const { breadCrumbs } = useSettingsContext();
  if (!breadCrumbs) return null;
  const pagePath = useMemo(() => {
    return backPage === "profile"
      ? "my-profile/0"
      : `/employees/${breadCrumbs?.empId}/${tabId || 8}`;
  }, [breadCrumbs, backPage]);
  return (
    <>
      <Grid
        container
        sx={{ alignItems: "center", justifyContent: "space-between" }}
        className="detail-page-top"
      >
        <Grid item={true} sm={4} md={5} lg={6}>
          <Box>
            <Breadcrumbs
              aria-label="breadcrumb"
              separator={<NavigateNextIcon fontSize="small" />}
              className="breadcrumb"
            >
              <Link
                style={{ textDecoration: "none" }}
                to={`/${backPage === "profile" ? "my-profile" : "employees"}`}
              >
                <Typography color="text.primary" fontSize="14px">
                  Employee
                </Typography>
              </Link>
              <Link style={{ textDecoration: "none" }} to={pagePath}>
                <Typography color="text.primary" fontSize="14px">
                  {breadCrumbs.fullName}
                </Typography>
              </Link>
              <Typography color="text.primary" fontSize="14px">
                {breadCrumbs.formName}
              </Typography>
            </Breadcrumbs>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default FormBreadCrumbs;
